import {
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormMessage,
} from "@/components/ui/form";
import { Checkbox } from "@/components/ui/checkbox";
import { UseFormReturn } from "react-hook-form";
import { ListingFormValues } from "@/components/listings/filters/FilterSchema";
import { useAttributes } from "@/hooks/useAttributes"; // Import useAttributes

interface FeaturesSectionProps {
  form: UseFormReturn<ListingFormValues>;
}

const FeaturesSection = ({ form }: FeaturesSectionProps) => {
  const { data: attributes, isLoading } = useAttributes(); // Fetch attributes
  // Watch the 'attributes' field to get its current value and trigger re-renders
  const watchedAttributes = form.watch("attributes");

  if (isLoading) {
    return <div>Loading attributes...</div>; // Or a more sophisticated loading spinner
  }

  return (
    <FormField
      control={form.control}
      name="attributes" // Change name to "attributes"
      render={() => (
        <FormItem>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-2">
            {attributes?.map((attribute) => {
              // Check if this attribute's ID is included in the watchedAttributes array
              const isChecked = watchedAttributes?.includes(attribute.id);

              return (
                <FormItem
                  key={attribute.id} // Use attribute.id as key
                  className="flex flex-row items-start space-x-3 space-y-0"
                >
                  <FormControl>
                    <Checkbox
                      checked={isChecked}
                      onCheckedChange={(checked) => {
                        const currentAttributes =
                          form.getValues("attributes") || []; // Get current attributes
                        if (checked) {
                          // Add the attribute ID if it's not already in the array
                          if (!currentAttributes.includes(attribute.id)) {
                            form.setValue("attributes", [
                              ...currentAttributes,
                              attribute.id, // Store attribute ID
                            ]);
                          }
                        } else {
                          // Remove the attribute ID if it's in the array
                          form.setValue(
                            "attributes",
                            currentAttributes.filter(
                              (id) => id !== attribute.id
                            ) // Filter by ID
                          );
                        }
                      }}
                    />
                  </FormControl>
                  <FormLabel className="font-normal cursor-pointer">
                    {attribute.name} {/* Display attribute name */}
                  </FormLabel>
                </FormItem>
              );
            })}
          </div>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};

export default FeaturesSection;
